import { NetworkBasePopUp } from '../NetworkBasePopUp';
import { GzDialog } from '../../../../ui/gzDialog/component/GzDialog';
import { translateFn } from '../../../../utils/translator.helper';
import { NetworkPopUpType } from '../../network.pop-up.factory';
import { GzNetworkFeedbackFormWebComponent } from './component/GzNetworkFeedbackFormWebComponent';
import { NetworkFeedbackFormData, NetworkFeedbackInfo } from './helpers/types';
import { FeedbackHelper } from '../../../../utils/feedback/feedback.helper';
import {
  AccessibilitySelectorValues,
  accessibilitySelectorValueToLabelMap,
  actionsSelectorValueToLabelMap,
  NETWORK_V2_BETA_TYPE,
  TreeViewSelectorValues,
  treeViewSelectorValueToLabelMap,
} from './helpers/contants';

export class NetworkFeedbackFormWindow extends NetworkBasePopUp<GzNetworkFeedbackFormWebComponent> {
  protected title = translateFn('Submit feedback');
  private type: NetworkPopUpType = NetworkPopUpType.NETWORK_FEEDBACK_FORM;
  protected extraDialogConfigs: Partial<GzDialog> = {
    isWindow: true,
  };

  protected customSetup() {
    this.popUpContent = new GzNetworkFeedbackFormWebComponent();

    this.popUpFooterButtons = [
      {
        id: 'confirmButton',
        label: translateFn('Submit'),
        disabled: true,
      },
      {
        id: 'closeButton',
        label: translateFn('Cancel'),
      },
    ];
  }

  protected async handleConfirmButtonClicked(event: CustomEvent) {
    const feedbackFormData = this.popUpContent.getFormValue();

    const feedbackInfo: NetworkFeedbackInfo = this.parseFormData(feedbackFormData);

    FeedbackHelper.handleConfirmButtonClicked(NETWORK_V2_BETA_TYPE, feedbackInfo);
  }

  private parseFormData(formData: NetworkFeedbackFormData): NetworkFeedbackInfo {
    const feedbackKeyToForm: Map<keyof NetworkFeedbackInfo, string> = new Map([
      ['message', formData.generalFeedback],
      [
        'greatestBenefitOfNewTreeView',
        this.getTreeViewFeedback(formData.treeViewFeedback, formData.treeViewFeedbackText),
      ],
      ['mostUsefulCategoriesOfFiltersAndSw', formData.filtersFeedbackOne],
      ['informationSearchedInNetwork', formData.filtersFeedbackTwo],
      ['mostFrequentActions', formData.actionsFeedbackOne],
      ['actionsListAccessMethod', this.getActionsListAccessMethod(formData.actionsFeedbackTwo)],
      [
        'mostImportantThingToAccess',
        this.getMostImportantThingToAccessFeedback(
          formData.accessibilityFeedbackOne,
          formData.accessibilityFeedbackOneText
        ),
      ],
      ['newInterfaceFeedback', formData.accessibilityFeedbackTwo],
    ]);

    const feedbackInfo: NetworkFeedbackInfo = {
      message: '',
      greatestBenefitOfNewTreeView: '',
      mostUsefulCategoriesOfFiltersAndSw: '',
      informationSearchedInNetwork: '',
      mostFrequentActions: '',
      actionsListAccessMethod: '',
      mostImportantThingToAccess: '',
      newInterfaceFeedback: '',
    };

    return FeedbackHelper.trimFeedbackData<NetworkFeedbackInfo>(feedbackInfo, feedbackKeyToForm);
  }

  private getTreeViewFeedback(treeViewFeedbackOption: string, treeViewFeedbackOtherOptionText: string): string {
    return treeViewFeedbackOption === TreeViewSelectorValues.Other
      ? treeViewFeedbackOtherOptionText
      : treeViewSelectorValueToLabelMap.get(treeViewFeedbackOption)!;
  }

  private getMostImportantThingToAccessFeedback(
    mostImportantThingFeedbackOption: string,
    mostImportantThingFeedbackOtherOptionText: string
  ): string {
    return mostImportantThingFeedbackOption === AccessibilitySelectorValues.Other
      ? mostImportantThingFeedbackOtherOptionText
      : accessibilitySelectorValueToLabelMap.get(mostImportantThingFeedbackOption)!;
  }

  private getActionsListAccessMethod(actionsListAccessMethodFeedbackOption: string): string {
    return actionsSelectorValueToLabelMap.get(actionsListAccessMethodFeedbackOption)!;
  }

  protected handleCancelButtonClicked(event: CustomEvent): void {
    return;
  }
}
